<template>
    <div class="header bgStyle flex-between">
        <div class="logo">
            <i class="iconfont icon-maisiduowei" :style="this.$route.path == '/cloudLab'?'color:white':''"></i>
        </div>
        <div class="nav_wrap flex-between">
                <li v-for="item in routerList" :key="item.id"  @click="setRouter(item.path)" :class="{active:item.path == $store.state.routerPath}"  >{{item.title}}</li>
        </div>
        <div class="header-right">
            <div class="header-user-con">
                <el-dropdown @command="toNextPage">
                    <div class="user" >
                        <el-avatar :size="35" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                        <span class="user-avator">{{userName}}</span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="/personalCenter">个人中心</el-dropdown-item>
                      <el-dropdown-item command="/modifyInfo">个人设置</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-divider class="ml20" direction="vertical"></el-divider>
                <el-button type="text" class="ml20 loginout" @click="loginoutUser" v-if="this.$route.path != '/personalCenter' && this.$route.path != '/modifyInfo'">退出</el-button>
                <el-button type="text" class="ml20 loginout" @click="loginoutUser" v-else>返回</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import bus from '../common/bus';
import { loginOut } from '../../utils/api'
export default {
    data() {
        return {
            routerList:[{
                id:0,
                title:'首页',
                path:'/index'
            },{
                id:1,
                title:'数据资源',
                path:'/dataResources'
            },{
                id:2,
                title:'云实验室',
                path:'/cloudLab'
            },{
                id:3,
                title:'案例系统',
                path:'/caseAnalysis'
            },{
                id:4,
                title:'云课堂',
                path:'/cloudClassroom'
            },{
                id:5,
                title:'共享社区',
                path:'/community'
            },{
                id:6,
                title:'竞赛与任务',
                path:'/competition'
            }],
            routerPath:this.$store.state.routerPath,
            userName: this.$store.state.userName,
            avatar: this.$store.state.userAvatar,
        };
    },
    mounted(){
        this.userName = this.$store.state.userName
        bus.$on('updateAvatar',avatar => {
            this.avatar = avatar
        })
        bus.$on('updateAccount',userName => {
            this.userName = userName
        })
    },
    methods: {
        //保存路由导航
        setRouter(path){
            this.$router.push(path)
            this.$store.commit('setRouterPath',{routerPath:path})
        },

        //退出登录。清除store，session，并跳转路径
        loginoutUser() {
            if(this.$route.path != '/personalCenter' && this.$route.path != '/modifyInfo'){
                loginOut().then(res => {
                    this.$router.replace('/login')
                    this.$store.replaceState({})
                    sessionStorage.clear()
                }).catch(err => {})
                
            }else{
                this.$router.go(-1)
            }
            
            // location.reload()
        }, 
        
        //去下一个页面，个人中心或者个人设置
        toNextPage(command){
            this.$router.push(`${command}`)
        },
    },
};
</script>
<style scoped lang="scss">
.bgStyle{
    background: #5277F7;
    color: white;
    box-shadow: 0px 3px 2px 2px rgba(105,105,105,0.16);
}

.loginout{
    font-size: 19px;
}
.active{
       font-weight: 400;
       font-size: 20px;
       color:  white;
       font-weight: 600;
       margin-top: 8px;
       padding-bottom: 8px;
       
   }
li:hover{
    cursor:pointer;
    font-weight: 600;
    color:  white;
    padding-bottom: 8px;
    border-bottom: 3px solid white;
}
.nav_wrap{
    width: 40%;
    font-size: 20px;
    margin-left: 25%;
}
.goBack{
    cursor: pointer;
    line-height: 60px;
    height: 60px;
    font-size: 16px;
    font-weight: bold;
    margin-left: 20px;
}
.goBack i{
    color: white;
    font-size: 20px;
}
.header {
    position: fixed;
    box-sizing: border-box;
    z-index: 6;
    width: 100%;
    padding: 35px 0px;
    height: 60px;
    font-size: 16px;
}
.header .logo {
    float: left;
    width: 170px;
    height: 40px;
    margin-left: 20px;
}
.header .logo .icon-maisiduowei{
    font-size: 30px;
    margin-left: 60px;
    color: white;
}
.header-right {
    float: right;
    padding-right: 50px;
}

/deep/.el-dropdown-menu__item{
        background: #5277F7;
        color: white;
    }
/deep/.el-dropdown-menu__item:hover{
    padding: 0px;
    height: 40px;
    line-height: 40px;
    text-align: center;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
    
    .user{
        display: inline-flex;
        align-items: center;
        cursor: pointer;
    }
}
.user-avator {
    margin-left: 10px;
    
}
.ml20{
    margin-left: 20px;
}
.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    
}
/deep/.el-avatar--circle {
    border: 2px solid white;
}
ul{
    font-size: 18px;
    color: white;  
    border: none;
    background-color: #5277F7 !important;
}
.header-right .el-button--text{
    color: white;
}
.header-right .el-divider--vertical{
    width: 2px;
    height: 15px;
}
.header-right .el-divider{
    background-color: white;
}
/deep/.el-dropdown{
    color: white;
    
}
</style>
